/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Email to send to winners of a sponsored competition
 * @export
 * @interface SponsoredRewardEmail
 */
export interface SponsoredRewardEmail {
    /**
     * Subject of the email to send to winners
     * @type {string}
     * @memberof SponsoredRewardEmail
     */
    subject: string;
    /**
     * Body of the email to send to winners
     * @type {string}
     * @memberof SponsoredRewardEmail
     */
    body: string;
}

/**
 * Check if a given object implements the SponsoredRewardEmail interface.
 */
export function instanceOfSponsoredRewardEmail(value: object): value is SponsoredRewardEmail {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function SponsoredRewardEmailFromJSON(json: any): SponsoredRewardEmail {
    return SponsoredRewardEmailFromJSONTyped(json, false);
}

export function SponsoredRewardEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredRewardEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'body': json['body'],
    };
}

export function SponsoredRewardEmailToJSON(json: any): SponsoredRewardEmail {
    return SponsoredRewardEmailToJSONTyped(json, false);
}

export function SponsoredRewardEmailToJSONTyped(value?: SponsoredRewardEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'body': value['body'],
    };
}

